import { FC } from "react";
import { Box, Typography } from "@mui/material";
import StyledWrapper from "./partners-grid.styles";
import { PartnersItem } from "../../../types/partners-item.type";

type Tier = "main" | "special" | "partner" | "separated";

type Props = {
  title: string;
  list: PartnersItem[];
  tier?: Tier;
};

const PartnersGrid: FC<Props> = ({ title, list, tier }) => {
  const handleClick = (url: string) => {
    if (url) window.open(url, "_blank");
  };
  return (
    <StyledWrapper className={tier ? `tier-${tier}` : undefined}>
      {title && (
        <Typography className="partners-subtitle" variant="mainSemiBold">
          {title}
        </Typography>
      )}
      <Box className="partners-grid-container">
        {list.map((item, index) => (
          <Box
            key={(tier || "") + index}
            className="partners-grid-item"
            sx={{ cursor: item.link ? "pointer" : "unset" }}
            onClick={() => handleClick(item.link)}
          >
            <img src={item.image} alt="" />
          </Box>
        ))}
      </Box>
    </StyledWrapper>
  );
};

export default PartnersGrid;
